
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/sustainability",
      function () {
        return require("private-next-pages/about-us/sustainability.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/sustainability"])
      });
    }
  